import * as queryString from 'query-string';
import { DEFAULT_DIGIT_INPUT_COUNT } from '../../utils/constants';

export interface QueryParameters {
    user: string | null;
    code: number[] | null;
}

function parseCode(code: string): number[] | null {
    const codeNumberArray: number[] = [];
    for (let i = 0; i < code.length; i++) {
        let digit = parseInt(code[i], 10);
        if (!isNaN(digit)) {
            codeNumberArray.push(digit);
        }
    }
    return codeNumberArray.length === DEFAULT_DIGIT_INPUT_COUNT ?
        codeNumberArray : 
        null;
}

export function extractQueryParameters(location: { search: any }): QueryParameters {
    const result: QueryParameters = {
        user: null,
        code: null
    };

    let queryStringParams: { email: string; code: string } | null = null;
    if (location && location.search) {
        queryStringParams = queryString.parse(location.search);
    }

    if (queryStringParams) {
        result.user = queryStringParams.email || null;
         
        if (queryStringParams.code) {
            const code: number[] | null = parseCode(queryStringParams.code);
            if (code) { result.code = code; }
        }
    }

    return result;
}

export function tryQueryParameterCodeConfirmation(queryParameters: QueryParameters, confirmCode: (user: string, code: number[]) => void): void {
    if (queryParameters.user && queryParameters.code && queryParameters.code.length === DEFAULT_DIGIT_INPUT_COUNT) {
        confirmCode(queryParameters.user, queryParameters.code);
    }
}



// WEBPACK FOOTER //
// ./src/webportal/components/authentication/authenticationUtility.ts